export default "__VITE_ASSET__DFNEl8pO__"